import { render } from "./UploadPatients.vue?vue&type=template&id=1a2fc125&scoped=true"
import script from "./UploadPatients.vue?vue&type=script&lang=js"
export * from "./UploadPatients.vue?vue&type=script&lang=js"

import "./UploadPatients.vue?vue&type=style&index=0&id=1a2fc125&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2fc125"]])

export default __exports__